import React, { useEffect, useState } from 'react';
import Desktop from '../assets/images/desktop.jpg';
import Repo from './repo';

export default function Github() {
  const [repos, setRepos] = useState([]);
  const [reposCount, setReposCount] = useState([]);

  useEffect(() => {
    const data = sessionStorage.getItem('repos');
    let myRepos;

    if (data) {
      myRepos = JSON.parse(data);

      setReposCount(myRepos.length);

      myRepos = myRepos.slice(1, 6);
      return setRepos(myRepos);
    }
    async function fetchRepos() {
      const response = await fetch(
        'https://api.github.com/users/patcm10/repos'
      );
      myRepos = await response.json();
      setReposCount(myRepos.length);

      sessionStorage.setItem('repos', JSON.stringify(myRepos));
      myRepos = myRepos.slice(1, 6);

      setRepos(myRepos);
    }

    fetchRepos();
  }, []);
  return (
    <section id="projects" className="projects-section bg-black">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-xl-8 col-lg-7">
            <img
              className="img-fluid mb-3 mb-lg-0 rounded"
              src={Desktop}
              alt=""
            />
          </div>
          <div className="col-lg-6 col-lg-5">
            <div className="bg-black featured-text text-center text-lg-left">
              <div className="project-text w-100 my-auto">
                <header className="text-center">
                  <h4 className="text-white">Projects</h4>
                  <p className="text-white-50 mb-0 p-2 mt-0">
                    Collaboration and code contribution
                  </p>
                </header>
                <ul className="repos-list text-white-50">
                  {repos.map(repo => {
                    return <Repo repo={repo} key={repo.id} />;
                  })}
                </ul>
                <div className="mt-8 text-center">
                  <a
                    href="https://github.com/patcm10"
                    className="btn btn-primary mx-auto"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    See more on Github ({reposCount})
                  </a>
                  <hr className="d-none d-lg-block mb-0 mr-0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
